'use client'

import { RefreshCw, Sparkles } from 'lucide-react'

// Presentational half of the AI-generate widgets — three states (idle,
// generating + cancel, regenerate) matching the CTT campaign generator's
// original look exactly, so every AI widget in the backoffice reads as the
// same feature rather than a one-off per screen.
export function AIGenerateButton({
  generating,
  generatedOnce,
  onGenerate,
  onCancel,
  disabled,
  borderClass,
  mutedClass,
  idleLabel = 'Generate with AI',
  regenerateLabel = 'Regenerate',
  generatingLabel = 'Generating…',
}: {
  generating: boolean
  generatedOnce: boolean
  onGenerate: () => void
  onCancel: () => void
  disabled?: boolean
  borderClass: string
  mutedClass: string
  idleLabel?: string
  regenerateLabel?: string
  generatingLabel?: string
}) {
  if (generating) {
    return (
      <>
        <span className={`inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono text-[9px] uppercase tracking-widest animate-pulse ${borderClass} ${mutedClass}`}>
          <Sparkles className="h-3 w-3" />
          {generatingLabel}
        </span>
        <button onClick={onCancel} className="border px-2 py-1 font-mono text-[9px] uppercase tracking-widest border-destructive/40 text-destructive hover:bg-danger-surface">
          Cancel
        </button>
      </>
    )
  }

  if (generatedOnce) {
    return (
      <button
        onClick={onGenerate}
        disabled={disabled}
        className={`inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono text-[9px] uppercase tracking-widest transition-colors disabled:opacity-50 ${borderClass} ${mutedClass} hover:border-violet-700 hover:text-violet-400`}
      >
        <RefreshCw className="h-3 w-3" />
        {regenerateLabel}
      </button>
    )
  }

  return (
    <button
      onClick={onGenerate}
      disabled={disabled}
      className="inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono text-[9px] uppercase tracking-widest transition-colors disabled:opacity-50 border-violet-700 bg-violet-950/20 text-violet-400 hover:bg-violet-950/40"
    >
      <Sparkles className="h-3 w-3" />
      {idleLabel}
    </button>
  )
}
